var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBatteryUnknown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_26308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6668 13.3333C31.4032 13.3333 32.0002 13.9303 32.0002 14.6666V17.3333C32.0002 18.0697 31.4032 18.6666 30.6668 18.6666C29.9304 18.6666 29.3335 18.0697 29.3335 17.3333V14.6666C29.3335 13.9303 29.9304 13.3333 30.6668 13.3333Z",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4199 4.20702C22.8104 3.81649 23.4444 3.81649 23.835 4.20702C24.2252 4.59746 24.2251 5.23061 23.835 5.62108L2.62109 26.834C2.23057 27.2245 1.59756 27.2245 1.20703 26.834C0.816773 26.4434 0.816596 25.8103 1.20703 25.4199L1.96094 24.665C0.994953 24.1667 0.333036 23.1618 0.333008 22V9.99999C0.333008 8.34321 1.67627 7.00012 3.33301 6.99999H19.627L22.4199 4.20702ZM24.6777 7.32127C25.6585 7.81462 26.333 8.82723 26.333 9.99999V22C26.333 23.6568 24.9898 25 23.333 25H7L9 23H23.333C23.8853 23 24.333 22.5522 24.333 22V9.99999C24.333 9.4477 23.8853 8.99999 23.333 8.99999H23L24.6777 7.32127ZM3.33301 8.99999C2.78084 9.00012 2.33301 9.44778 2.33301 9.99999V22C2.33305 22.5522 2.78086 22.9999 3.33301 23H3.62695L17.627 8.99999H3.33301Z",
    fill: "#f0ab00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_26308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBatteryUnknown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery-unknown.58d2ad5cc9b5aaed2bb0b6daa3148983.svg";